<template>
    <v-text-field        
        @update:modelValue="$emit('update:modelValue', $event.toString().toUpperCase())"
        >
    </v-text-field>
</template>

<script setup lang="ts">
    defineEmits(["update:modelValue"]);
</script>